<!-- 相似商品列表 -->
<template>
  <div class="container">
    <div class="handle-box">
      <table-list
        :loading="loading"
        :table-data="tableData"
        :table-label="tableLabel"
      >
       <!-- eslint-disable-next-line -->
        <template slot="订单是否确认">
            <span>订单是否确认</span>
        <el-tooltip class="item" effect="dark" placement="top-start">
          <div slot="content">
            选择”否”项表示不需要确认即生成有效订单（集成订单使用无效），默认订单都需要确认。
          </div>
          <i class="el-icon-question"></i>
        </el-tooltip>
         </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:defaultImage="slot">
          <img
            class="sku-img"
            :src="slot.scope.row.defaultImage"
            alt=""
          />
        </template>
      </table-list>
      <!-- <div class="pagination">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="productTagPage.currentPage"
          :page-size="productTagPage.pageSize"
          :total="productTagPage.pageTotal"
          :small="true"
        >
        </el-pagination>
      </div> -->
    </div>
  </div>
</template>

<script>
import tableList from "../../common/e-table-list.vue"
import api from "../../../api/product/index.js";
export default {
    props: {
    // tableHeadData: {
    //   type: Array,
    //   default: () => {
    //     return [];
    //   },
    // },
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      loading: false,
        tableLabel: [
        { label: '图片', param: 'defaultImage', align: 'center', slot:'defaultImage',isBatch:false},
        { label: '商品名称', param: 'skuName', align: 'center'},
          { label: '规格', param: 'specificationStr', align: 'center' },
        { label: '库存', param: 'skuStock', align: 'center' },
        { label: '起订量', param: 'minOrderQuantity', align: 'center' },
         { label: '订单是否确认', param: 'isConfirm', align: 'center' ,render:  (row) => {
            if (row.isConfirm === 1) {
              return '是'
            } else if (row.isConfirm === 0) {
              return '否'
            }
          }, header: true,        
        },
        { label: '发货周期(天)', param: 'deliverTime', align: 'center' },
        { label: '计量单位', param: 'unitValue', align: 'center' },
        { label: '市场公开价(元)', param: 'price', align: 'center' },
        ],
      productTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      queryParams:{
        pageNum:1,
        pageSize:10
      }
    };
  },

  components: {
      tableList
  },

  computed: {},

  created() {
      // let id =  localStorage.getItem('isExistProductGroupProductId');
      // let isExistProductGroup = localStorage.getItem('isExistProductGroup');
      // if(isExistProductGroup == 'true'){
      //    this.queryParams.productId = id;
      // this.getSameAttrSkusByProducId(this.queryParams);
      // }
     
  },
  methods: {
       //获取相同属性商品
    async getSameAttrSkusByProducId(params) {
              // let id =  localStorage.getItem('isExistProductGroupProductId');

      let res = await api.getSameAttrSkusByProducId(params);
      if (res.code == 200) {
        console.log(res);
        this.tableData = res.data.records;
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.btn-content {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.sku-img{
  width: 48px;
  height: 48px;
}
</style>